import { PRIVATE_MODULES_PATH } from "./root.path";

const BASE = PRIVATE_MODULES_PATH.TOOLS;
const _ = (...arg: any[]) => "/" + BASE + "/" + arg.join("/");

// create path router
const ROUTER = {
  ROOT: "",
  SECTOR_PROPOSALS: "sector-proposals",
  SECTOR_PROPOSALS_CREATE: "sector-proposals/create"
};

// create path routes
const PATH = {
  ROOT: _(),
  SECTOR_PROPOSALS: _("sector-proposals"),
  SECTOR_PROPOSALS_CREATE: _("sector-proposals", "create")
};

// export
const TOOLS_PATH = {
  ROUTES: PATH,
  ROUTER
};

export default TOOLS_PATH;
